export function DigitalAssetsColors() {
  return (
    <div className={"scroll-area colors"}>
      <div className={"assets-banner mobile-only"}>
        <div>
          <p>Brand Elements</p>
          <div className={"border-el"}/>
          <h1>Colors</h1>
        </div>
      </div>
      <section className={"one"}>
        <h2>Main Brand Colors</h2>
        <p>Used for all primary marketing and site UI</p>
        <div className={"color-flex"}>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#e42436'}}/>
            <p>
              <b>Red</b>
              <br/>
              #E42436
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#fd5c69'}}/>
            <p>
              <b>Poppy</b>
              <br/>
              #FD5C69
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#fff0f1'}}/>
            <p>
              <b>Light Pink</b>
              <br/>
              #FFF0F1
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: 'linear-gradient(90deg, #e42436 0%, #fd5c69 100%)'}}/>
            <p>
              <b>Red &gt; Poppy Gradient</b>
              <br/>
              #E42436 &gt; #FD5C69
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#333333'}}/>
            <p>
              <b>Dark Grey 1</b>
              <br/>
              #333333
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#565656'}}/>
            <p>
              <b>Dark Grey 2</b>
              <br/>
              #565656
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#777777'}}/>
            <p>
              <b>Dark Grey 3</b>
              <br/>
              #777777
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#999999'}}/>
            <p>
              <b>Medium Grey 1</b>
              <br/>
              #999999
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#cfcfcf'}}/>
            <p>
              <b>Medium Grey 2</b>
              <br/>
              #CFCFCF
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#efefef'}}/>
            <p>
              <b>Light Grey 1</b>
              <br/>
              #EFEFEF
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#fafafa'}}/>
            <p>
              <b>Light Grey 2</b>
              <br/>
              #FAFAFA
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#ffffff', border: '1px solid #cfcfcf'}}/>
            <p>
              <b>White</b>
              <br/>
              #FFFFFF
            </p>
          </div>
        </div>
      </section>
      <section className={"two"}>
        <h2>Pro Plan</h2>
        <p>Used for Pro related marketing</p>
        <div className={"color-flex"}>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#e7b853'}}/>
            <p>
              <b>Pro Gold</b>
              <br/>
              #E7B853
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#c39940'}}/>
            <p>
              <b>Dark Gold</b>
              <br/>
              #C39940
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: 'linear-gradient(90deg, #D3A23B 0%, #FFD270 100%)'}}/>
            <p>
              <b>Dark Gold &gt; Light Gold Gradient</b>
              <br/>
              #D3A23B &gt; #FFD270
            </p>
          </div>
        </div>
      </section>      
      <section className={"three"}>
        <h2>Teams & Locations</h2>
        <p>Used for Teams and Locations related marketing</p>
        <div className={"color-flex"}>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#FEB45C'}}/>
            <p>
              <b>Teams Orange</b>
              <br/>
              #FEB45C
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#5E76FC'}}/>
            <p>
              <b>Locations Blue</b>
              <br/>
              #5E76FC
            </p>
          </div>
        </div>
      </section>
      <section className={"four"}>
        <h2>Pastels</h2>
        <p>Only used for backgrounds of site category banners and product thumbnails</p>
        <div className={"color-flex"}>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#FFE2E0'}}/>
            <p>
              <b>Strawberry</b>
              <br/>
              #FFE2E0
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#FCE5D4'}}/>
            <p>
              <b>Melon</b>
              <br/>
              #FCE5D4
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#FFF7D9'}}/>
            <p>
              <b>Lemon</b>
              <br/>
              #FFF7D9
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#EFF7E7'}}/>
            <p>
              <b>Avocado</b>
              <br/>
              #EFF7E7
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#EDF7FA'}}/>
            <p>
              <b>Sky Blue</b>
              <br/>
              #EDF7FA
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#F2F0FD'}}/>
            <p>
              <b>Lavender</b>
              <br/>
              #F2F0FD
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"} style={{background: '#F4EFEA'}}/>
            <p>
              <b>Beige</b>
              <br/>
              #F4EFEA
            </p>
          </div>
          <div className={"swatch-container"}>
            <div className={"swatch"}/>
          </div>
        </div>
      </section>
    </div>
  )
}